function addError(errors, key, message) {
    errors[key] ??= [];
    if (!errors[key].includes(message))
        errors[key].push(message);
}
const ISBN_REGEX = /^97[89]\d{10}$/;
export function getCampaignCodeError(contract, errors) {
    if (contract.campaign_code === undefined)
        return errors;
    if (!contract.campaign_code.trim()) {
        addError(errors, "campaign_code", "Kampanjekode må fylles ut. ");
    }
    else if (!contract.sku?.trim()) {
        addError(errors, "campaign_code", "Ukjent kampanjekode. Den må finnes i Sanity og peke på et produkt. ");
    }
    return errors;
}
export function getSelectedProductsErrors(contract, errors, subscriptionProducts) {
    const selectedSkus = contract.selected_skus;
    const sku = contract.sku?.trim();
    if (!selectedSkus || !sku)
        return errors;
    const product = subscriptionProducts.get(sku);
    if (!product) {
        addError(errors, "sku", "Fant ikke produktet i Crystallize. ");
        return errors;
    }
    if (!product.isBookClub) {
        addError(errors, "sku", "Produktet er ikke en bokklubb. ");
        return errors;
    }
    const sections = product.gifts.sections?.length
        ? product.gifts.sections
        : [{ count: product.gifts.count, items: product.gifts.items }];
    const seenSkus = new Set();
    for (const selectedSku of selectedSkus) {
        if (seenSkus.has(selectedSku)) {
            addError(errors, "selected_skus", `${selectedSku} står to ganger. `);
        }
        seenSkus.add(selectedSku);
        const isOnOffer = sections.some((section) => section.items.some((item) => item.sku === selectedSku));
        if (!isOnOffer) {
            addError(errors, "selected_skus", `${selectedSku} er ikke med i tilbudet. `);
        }
    }
    for (const section of sections) {
        const chosenCount = section.items.filter((item) => seenSkus.has(item.sku)).length;
        if (chosenCount === section.count)
            continue;
        const isBookList = section.items.every((item) => ISBN_REGEX.test(item.sku));
        const label = isBookList
            ? section.count === 1
                ? "bok"
                : "bøker"
            : section.count === 1
                ? "gave"
                : "gaver";
        addError(errors, "selected_skus", `Skal ha ${section.count} ${label} fra tilbudet, fant ${chosenCount}. `);
    }
    return errors;
}
